import React, { useEffect, useRef, useState } from 'react';

const Skills = () => {
    const [skillsAnimated, setSkillsAnimated] = useState(false);
    const skillsRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !skillsAnimated) {
                    setSkillsAnimated(true);
                }
            },
            { threshold: 0.3 }
        );

        if (skillsRef.current) {
            observer.observe(skillsRef.current);
        }

        return () => observer.disconnect();
    }, [skillsAnimated]);

    const skillBars = [
        { name: 'UI/UX Design', percentage: 95 },
        { name: 'Front-end Development', percentage: 90 },
        { name: 'Responsive Design', percentage: 98 },
        { name: 'Branding & Identity', percentage: 85 }
    ];

    return (
        <section className="skills" id="skills">
            <div className="container">
                <div className="section-header" data-scroll-reveal>
                    <span className="section-number">03</span>
                    <h2 className="section-title">Skills & Expertise</h2>
                </div>
                <div className="skills-content">
                    <div className="skills-grid">
                        <div className="skill-category" data-scroll-reveal>
                            <div className="skill-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M12 2L2 7l10 5 10-5-10-5z" />
                                    <path d="M2 17l10 5 10-5M2 12l10 5 10-5" />
                                </svg>
                            </div>
                            <h3 className="skill-title">Design</h3>
                            <ul className="skill-list">
                                <li>UI/UX Design</li>
                                <li>Visual Design</li>
                                <li>Branding</li>
                                <li>Prototyping</li>
                                <li>Design Systems</li>
                            </ul>
                        </div>

                        <div className="skill-category" data-scroll-reveal>
                            <div className="skill-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="16 18 22 12 16 6" />
                                    <polyline points="8 6 2 12 8 18" />
                                </svg>
                            </div>
                            <h3 className="skill-title">Development</h3>
                            <ul className="skill-list">
                                <li>HTML/CSS/JavaScript</li>
                                <li>React & Vue.js</li>
                                <li>Node.js</li>
                                <li>Responsive Design</li>
                                <li>Web Performance</li>
                            </ul>
                        </div>

                        <div className="skill-category" data-scroll-reveal>
                            <div className="skill-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="2" y="3" width="20" height="14" rx="2" />
                                    <line x1="8" y1="21" x2="16" y2="21" />
                                    <line x1="12" y1="17" x2="12" y2="21" />
                                </svg>
                            </div>
                            <h3 className="skill-title">Tools</h3>
                            <ul className="skill-list">
                                <li>Figma & Adobe XD</li>
                                <li>Photoshop & Illustrator</li>
                                <li>Git & GitHub</li>
                                <li>VS Code</li>
                                <li>Webflow & Framer</li>
                            </ul>
                        </div>
                    </div>

                    <div className="skills-visual" data-scroll-reveal ref={skillsRef}>
                        <div className="skill-bar-wrapper">
                            {skillBars.map((skill, index) => (
                                <div className="skill-bar-item" key={index}>
                                    <div className="skill-bar-header">
                                        <span>{skill.name}</span>
                                        <span>{skill.percentage}%</span>
                                    </div>
                                    <div className="skill-bar">
                                        <div
                                            className={`skill-bar-fill ${skillsAnimated ? 'animated' : ''}`}
                                            style={{
                                                '--target-width': `${skill.percentage}%`,
                                                transitionDelay: `${index * 0.2}s`
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Skills;
